import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  OnDestroy,
  OnInit,
  output,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DropdownObject } from '@inmoment/the-kitchen';

import { AppSharedModule } from '../../../../../app-shared.module';
import { WidgetDataSource } from '../../../../../models';
import { Widget } from '../../../../../providers/bridge-api/dashboard.service';
import { GridAnalyticItemConfigSectionComponent } from '../grid-analytic-item-config-section/grid-analytic-item-config-section.component';
import { ChartDateInterval } from '../../widget-chart/widget-chart.component';

@Component({
  selector: 'app-grid-breakdown-date-config',
  standalone: true,
  imports: [CommonModule, AppSharedModule],
  templateUrl: './grid-breakdown-date-config.component.html',
  styleUrl: './grid-breakdown-date-config.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridBreakdownDateConfigComponent
  extends GridAnalyticItemConfigSectionComponent
  implements OnInit, OnDestroy
{
  disabled = input<boolean>(false);
  widgetDataSource = input<WidgetDataSource>();
  widget = input<Widget>();
  value = input<string>();
  timeIntervalOptions = computed<DropdownObject[]>(() => this.getTimeIntervalOptions(), {
    debugName: 'getTimeIntervalOptions',
  });
  form: FormGroup;
  private fb = inject(FormBuilder);
  private subs = new Subscription();
  onValueChange = output<string>();

  ngOnInit(): void {
    this.buildForm();
    if (this.value()) {
      this.patchForm(this.value());
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private buildForm() {
    this.form = this.fb.group({
      timeInterval: this.fb.control({
        value: ChartDateInterval.find((v) => v === 'month'),
        disabled: this.disabled(),
      }),
    });
    this.onValueChange.emit(this.form.controls.timeInterval.value);

    this.subs.add(
      this.form.controls.timeInterval.valueChanges.subscribe((value) =>
        this.onValueChange.emit(value)
      )
    );
  }

  private patchForm(value) {
    this.form.controls.timeInterval.setValue(value);
  }
}
